import React from 'react';
import { Form } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { NO_AVAILABLE_HOURS_MESSAGE } from './ReservationTimeSelect.constants';
import { getReservationTimeOptions, getReservationTimeSelectValue } from './ReservationTimeSelect.utils';
import { LocationPropType } from '../../../../../services/proptypes';
import './ReservationTimeSelect.css';
var defaultProps = {
  reservationDate: null,
  location: null,
  value: ''
};
export default function ReservationTimeSelect(_ref) {
  var value = _ref.value,
    location = _ref.location,
    reservationDate = _ref.reservationDate,
    onChange = _ref.onChange;
  var reservationTimeOptions = getReservationTimeOptions(location, reservationDate);
  var displaySelect = !_isEmpty(reservationTimeOptions) || !reservationDate;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Select, {
    required: true,
    label: "Reservation Time",
    placeholder: displaySelect ? 'Select Hour' : NO_AVAILABLE_HOURS_MESSAGE,
    value: getReservationTimeSelectValue(value, reservationTimeOptions),
    className: "reservation-time-select ".concat(!displaySelect && 'no-pointer'),
    name: "reservationTime",
    onChange: onChange,
    options: reservationTimeOptions
  }));
}
ReservationTimeSelect.defaultProps = defaultProps;